import { Box, Button, TextField } from "@mui/material";
import Combobox from "../../../components/common/Combobox";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import { FilterList } from "@mui/icons-material";
import { useState } from "react";
import localize from "../../../common/localize";

export default function SupplyFilter({ fullData, setDataFiltered }) {
  const [selectedSupplyFilter, setSelectedSupplyFilter] = useState(undefined);
  const [filterValue, setFilterValue] = useState("");

  const SupplyFilters = [
    {
      Id: "CODE",
      Name: localize.code,
    },
    {
      Id: "NAME",
      Name: localize.name,
    },
  ];

  const handleSupplyFilterSelection = (filter) => {
    setFilterValue("");
    setSelectedSupplyFilter(filter);
    if (filter) {
      return;
    }

    setDataFiltered && setDataFiltered(fullData);
  };

  const handleFilterBtn = () => {
    switch (selectedSupplyFilter.Id) {
      case "CODE":
        const filteredByCode = fullData?.filter(
          (x) =>
            x.SupplyElement?.Code.toString().toLowerCase() ===
            filterValue.toLowerCase()
        );
        setDataFiltered && setDataFiltered(filteredByCode);
        break;

      case "NAME":
        const filteredByName = fullData?.filter((x) =>
          x.SupplyElement?.Name.toString()
            .toLowerCase()
            .includes(filterValue.toLowerCase())
        );
        setDataFiltered && setDataFiltered(filteredByName);
        break;
    }
  };

  const handleFilterValueChange = (value) => {
    setFilterValue(value.target.value);
  };

  const keyUp = (e) => {
    if (e.key === "Enter") {
      handleFilterBtn();
    }
  };

  return (
    <Box className="flex flex-col gap-3 w-full">
      <Box className="w-full">
        <Combobox
          id="SuppliesFilter"
          handleValueChange={handleSupplyFilterSelection}
          fieldValue={selectedSupplyFilter}
          fieldOptions={SupplyFilters ?? []}
          fieldLabel={localize.filter_list}
        />
      </Box>

      {selectedSupplyFilter && (
        <Box className="flex gap-2 w-full">
          <Box className="flex gap-2 items-center w-full">
            <TextField
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              id="outlined-basic"
              name="FilterValue"
              label={selectedSupplyFilter.Name}
              variant="outlined"
              onChange={handleFilterValueChange}
              value={filterValue}
              onKeyUp={keyUp}
            />

            <Button
              style={{ width: "150px" }}
              disabled={
                !filterValue || filterValue.replaceAll(" ", "").length === 0
              }
              size="small"
              variant="contained"
              onClick={handleFilterBtn}
              className="btn app_button app_general_button_data btn-sm"
            >
              <span className="mr-2">{localize.filter}</span>
              <FilterList className="text-xs" />
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}
